import { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useRadioCoverages } from '../../../hooks/radioCoverage';



const LocationSelector = ({ onSelect }) => {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      onSelect({ lat, lng });
    },
  });
  return null;
};


const RadioCoverageModal = ({ open, customIcon, onClose}) => {
    const [position, setPosition] = useState(null);
    const [caseStudy, setCaseStudy] = useState({
        name : "",
        gatewayName : "",
        lat: "",
        lng: "",
        deviceName: "",
        createdAt: "",    
    });

    const userCoordinates = JSON.parse(localStorage.getItem("UserCoordinates"));
    
    const handleChange = (field) => (event) => {
        setCaseStudy((prev) => ({ ...prev, [field]: event.target.value }));
    };

    const handleMapClick = ({ lat, lng }) => {
        setCaseStudy((prev) => ({
          ...prev,
          lat: lat.toFixed(6),
          lng: lng.toFixed(6),
        }));
    };

    const {addRadioCoverage} = useRadioCoverages();

    const sendRadioCoverage = () => {
        addRadioCoverage(caseStudy);
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Mελέτη Ραδιοκάλυψης</DialogTitle>
            <DialogContent>
                <Box height={300} mb={2}>
                    <MapContainer
                        center={[userCoordinates.lat, userCoordinates.lng]}
                        zoom={13}
                        style={{ height: '100%', width: '100%' }}
                    >
                    
                        <TileLayer
                            url={`https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`}
                        />
                        
                        {caseStudy.lat && caseStudy.lng && (
                            <Marker
                                position={[parseFloat(caseStudy.lat), parseFloat(caseStudy.lng)]}
                                icon={customIcon}
                            />
                        )}

                        <LocationSelector onSelect={handleMapClick} />
                        
                        {position && <Marker position={[position.lat, position.lng]} />}

                    </MapContainer>
                </Box>
                
                <Box display="flex" flexDirection="column" gap={2}>
                    <TextField
                        label="Όνομα Μελέτης"
                        value={caseStudy.name}
                        onChange={handleChange('name')}
                    />

                    <TextField
                        label="Όνομα Gateway"
                        value={caseStudy.gatewayName}
                        onChange={handleChange('gatewayName')}
                    />

                    <TextField
                        label="Latitude"
                        value={caseStudy.lat}
                        onChange={handleChange('lat')}
                        variant="outlined"
                        InputLabel={{ shrink: true }}
                    />

                    <TextField
                        label="Longitude"
                        value={caseStudy.lng}
                        onChange={handleChange('lng')}
                        variant="outlined"
                        InputLabel={{ shrink: true }}
                    />

                    <TextField
                        label="Όνομα Συσκευής"
                        value={caseStudy.deviceName}
                        onChange={handleChange('deviceName')}
                    />

                </Box>
        
            </DialogContent>

            <DialogActions>
                <Button variant="contained" sx={{ mt: 2, alignSelf: 'flex-start' }} onClick={sendRadioCoverage}>Αποθήκευση</Button>
                <Button onClick={onClose}>Ακύρωση</Button>
            </DialogActions>
        </Dialog>

    );
};

export default RadioCoverageModal;